<script>
  import Conexoes from "../../Classes/Conexoes";
  import Constantes from "../../Classes/Constantes";
  import { DadosLogin } from "../../Classes/Stores";
  import CaixaDeDialogo from "../../componentes_basicos/CaixaDeDialogo.svelte";
  import CidadeEstado from "../../componentes_basicos/CidadeEstado.svelte";
  import DropDownDb from "../../componentes_basicos/DropDownDB_2.svelte";
  import Loading from "../../componentes_basicos/Loading.svelte";
  import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";

  import { onMount } from "svelte";
  import DataGridRel from "../../componentes_basicos/DataGridRel.svelte";
  export let params;
  let id_desafio = params;
  let conexao = new Conexoes();
  let isLoading = false;
  let carregando = false;
  let link_video = "";
  let box = "";
  let judge = "";
  let outro_box = "";
  let cidade_box = "";
  let nome_box = "";
  let cidade_outro_box = "";
  let showModal = false;
  let confirma = false;
  let confirma2 = false;
  let nomeEstadoSelecionado = "";
  let nomeCidadeSelecionada = "";
  let regras;
  let desafio;
  let quesitos = [];
  let respostas = [];
  let mensagemResult = "";
  let url = "";
  let isValid = false;
  let message = "";
  let JaRespondeu = false;

  let nome_usuario;
  let estado;
  let email;
  let cidade;
  let perguntasRespostas = [];
  let semDesafio = false;
  let exibeInputOutroBox = false;
  let config_drop_down = {
    api: Constantes.api_consultar_padrao,
    nome_coluna_opcoes: "box",
    nome_coluna_saida: "id",
    filtravel: true,
    itens: "",
    parametros: {
      query_code: "consulta_generica_livre",
      tabela: "box_view",
    },
  };

  async function submeterResultado() {
    isLoading = true;
    const resultado = {
      id_usuario: $DadosLogin.id_usuario,
      link_video,
      estado: nomeEstadoSelecionado,
      cidade: nomeCidadeSelecionada,
      box: box,
      judge: judge,
      outro_box: outro_box,
      cidade_outro_box: cidade_outro_box,
      respostas: respostas.reduce((acc, curr, index) => {
        acc[index] = curr;
        return acc;
      }, {}),
    };

    const response = await conexao.conecta(
      Constantes.api_respostas_desafios,
      resultado
    );
    if (response && response.success) {
      mensagemResult = Constantes.msg_inserido_sucesso;
    } else {
      mensagemResult = Constantes.msg_erro_conexao_bd;
    }
    isLoading = false;
  }

  async function BaixarRegras() {
    isLoading = true;
    let result = await conexao.conecta(Constantes.api_consultar_padrao, {
      query_code: Constantes.query_code_busca_desafio,
      id_desafio: id_desafio,
    });
    if (!result || result.length == 0) {
      semDesafio = true;
    }
    desafio = result[0].desafio;
    regras = result[0].regras;
    isLoading = false;
  }
  async function VerificaJaPreencheu() {
    isLoading = true;
    let result = await conexao.conecta(Constantes.api_consultar_padrao, {
      query_code: Constantes.query_code_busca_resposta_desafio,
      id_desafio: id_desafio,
      id_usuario: $DadosLogin.id_usuario,
    });
    if (result && result.length > 0) {
      JaRespondeu = true;
      nome_usuario = result[0].nome_usuario;
      email = result[0].email;
      estado = result[0].estado;
      cidade = result[0].cidade;
      link_video = result[0].link_video;
      nome_box = result[0].nome_box;
      cidade_box = result[0].cidade_box;
      judge = result[0].judge;

      perguntasRespostas = result;
    }

    isLoading = false;
  }
  async function BaixarQuesitos() {
    isLoading = true;
    let result = await conexao.conecta(Constantes.api_consultar_padrao, {
      query_code: Constantes.query_code_busca_desafio_quesitos,
      id_desafio: id_desafio,
    });

    quesitos = result;

    quesitos.forEach((element) => {
      respostas[element.id] = 0;
      console.log(respostas[element.id]);
    });

    isLoading = false;
  }

  onMount(() => {
    BaixarRegras();
    BaixarQuesitos();
    VerificaJaPreencheu();
  });
  async function RetornaDrops(e) {
    console.log(e.detail.objeto.box);
    if (e.detail.objeto.box == "OUTRO") {
      exibeInputOutroBox = true;
    } else {
      outro_box = "";
      cidade_outro_box = "";
      exibeInputOutroBox = false;
    }

    //console.log(e.detail.objeto);
  }
</script>

<main class="margem">
  {#if !semDesafio}
    {#if desafio}
      <div class="card">
        <div class="image-container">
          <img
            src="https://wodoxi.s3.amazonaws.com/img_publicas/desafio2.png"
            alt="Descrição da imagem"
          />
        </div>
        <div class="text-left">{@html desafio}</div>
      </div>
    {/if}

    {#if !JaRespondeu}
      <div>
        <p>Para cadastrar os desafios é preciso ler as regras</p>
        <input type="checkbox" bind:checked={confirma} /> Confirma que leu
        <a href="#" on:click={() => (showModal = true)}>regras do Desafio?</a>
        <hr />
      </div>

      {#if confirma}
        {#if !$DadosLogin.cidade}
          <CidadeEstado bind:nomeCidadeSelecionada bind:nomeEstadoSelecionado />
        {/if}

        <div style="display: flex; align-items: center;">
          <Loading {carregando} />
        </div>

        <strong>Selecione o Box onde realizou o Desafio ou selecione a opção "OUTRO":</strong>
        <div>
          <DropDownDb
            config={config_drop_down}
            on:retorno={(e) => RetornaDrops(e)}
            bind:saida={box}
          />
        </div>

        {#if exibeInputOutroBox}
          <div class="bordaGeral">
            Digite o Nome do Box:
            <div class="input-container">
              <input
                type="text"
                bind:value={outro_box}
                disabled={!confirma}
                style="width: 100%;"
              />
            </div>

            Digite a Cidade do Box:
            <div class="input-container">
              <input
                type="text"
                bind:value={cidade_outro_box}
                disabled={!confirma}
                style="width: 100%;"
              />
            </div>
          </div>
        {/if}

        <strong>Caso o Desafio tenha sido acompanhado, coloque o nome do Judge:</strong>
        <div class="input-container">
          <input
            type="text"
            bind:value={judge}
            disabled={!confirma}
            style="width: 100%;"
          />
        </div>

        <strong>Link do Vídeo:</strong>
        <div class="input-container">
          <input
            type="text"
            bind:value={link_video}
            disabled={!confirma}
            style="width: 100%;"
          />
        </div>

        <hr />
        <strong>Preencha seus resultados:</strong>

        {#each quesitos as quesito}
          <div class="bordaQuesitos">
            <label>
              {quesito.pergunta}
              <input
                style="font-size: 25px; font-family:verdana; font-weight: bold; text-align: center; background: #cbd4fd;"
                type="number"
                bind:value={respostas[quesito.id]}
                min="0"
                max={quesito.max_range}
                step={quesito.salto}
                disabled={confirma}
              />

              <div class="slider-container">
                <span style="font-size: 25px; font-family: Verdana, sans-serif;"
                  >-</span
                >
                <input
                  type="range"
                  bind:value={respostas[quesito.id]}
                  min="0"
                  max={quesito.max_range}
                  step={quesito.salto}
                  disabled={!confirma}
                />
                <span style="font-size: 25px; font-family: Verdana, sans-serif;"
                  >+</span
                >
              </div>
            </label>
            <br />
          </div>
        {/each}

        <div>
          <br />
          Confira os dados preenchidos, pois não será possível alterar o envio desses
          dados posteriormente.<br /><br />
          <input type="checkbox" bind:checked={confirma2} /> <b>Conferido</b>
        </div>

        <div>
          <button on:click={submeterResultado} disabled={!confirma2}
            >Submeter Resultado</button
          >
        </div>
      {/if}
    {:else}
      <div class="bordaGeral2">
        <div
          style="text-align: center; font-size: 22px; font-weight: bold; color: blue;"
        >
          DESAFIO JÁ RESPONDIDO
        </div>
        <br />
        <div style="font-size: 22px; font-weight: bold;">Suas respostas:</div>

        <div>
          <strong>Cidade/Estado: </strong>{cidade}/{estado}<br />
          <strong>Link do Vídeo: </strong>{link_video}<br />
          <strong>Box: </strong>
          {nome_box}/{cidade_box}<br />
          <strong>Judge: </strong>
          {judge}<br /><br />
        </div>

        <div>
          {#each perguntasRespostas as resposta}
            <strong
              >{resposta.pergunta}
              <span style="font-size: 22px; color: blue;"
                >{resposta.resposta}</span
              ></strong
            ><br />
          {/each}
        </div>
      </div>
    {/if}
  {:else}
    <h2>Desafio inválido!</h2>
  {/if}
</main>
<LoadingTela {isLoading} />
{#if showModal}
  <CaixaDeDialogo
    title="Regras"
    message={regras}
    on:close={() => {
      showModal = false;
    }}
  />
{/if}
<CaixaDeDialogo
  message={mensagemResult}
  on:close={() => {
    mensagemResult = "";
    window.location.reload();
  }}
/>

<style>
  .bordaGeral {
    border: 2px solid #000080; /* Define a borda com 2px de largura e cor preta */
    border-radius: 5px; /* Define o arredondamento dos cantos */
    background: #d3f3ff;
    padding: 10px; /* Adiciona um preenchimento interno à div */
  }

  .bordaGeral2 {
    border: 2px solid #000080; /* Define a borda com 2px de largura e cor preta */
    border-radius: 5px; /* Define o arredondamento dos cantos */
    background: #cfdcf8;
    padding: 10px; /* Adiciona um preenchimento interno à div */
  }

  .bordaQuesitos {
    border: 1px solid #ccc; /* Define a borda com 2px de largura e cor preta */
    border-radius: 5px; /* Define o arredondamento dos cantos */
    padding: 10px; /* Adiciona um preenchimento interno à div */
  }

  .slider-container {
    display: flex;
    align-items: center;
  }

  .slider-container input[type="range"] {
    appearance: none; /* removes browser-specific styling */
    width: 250px; /* width of slider */
    height: 15px; /* height of slider */
    background: #1976d2; /* orange background */
    outline: none; /* remove outline */
    border-radius: 50px; /* round corners */
  }

  .slider-container input[type="range"]::-webkit-slider-thumb {
    appearance: none; /* removes browser-specific styling */
    width: 20px; /* handle width */
    height: 20px; /* handle height */
    border: 2px solid #043b72;
    border-radius: 50%; /* make it circular */
    background: #ffffff; /* white color */
    cursor: pointer; /* cursor on hover */
  }

  main {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  label {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    color: #333;
  }

  .checkbox-label {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    color: #333;
  }

  input[type="checkbox"] {
    appearance: none;
    width: 18px;
    height: 18px;
    border: 2px solid #1976d2;
    border-radius: 4px;
    position: relative;
    cursor: pointer;
    outline: none;
    transition: all 0.3s;
  }

  input[type="checkbox"]:checked {
    background-color: #1976d2;
    border: 2px solid #1976d2;
  }

  input[type="checkbox"]:checked::before {
    content: "";
    position: absolute;
    top: 2px;
    left: 6px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  input[type="text"],
  input[type="number"],
  input[type="time"],
  select {
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    outline: none;
    transition:
      border-color 0.3s,
      box-shadow 0.3s;
  }

  input[type="text"]:focus,
  input[type="number"]:focus,
  input[type="time"]:focus,
  input[type="text"]:disabled,
  input[type="number"]:disabled,
  input[type="time"]:disabled,
  select {
    background-color: #ffffff;
    color: #000000;
  }

  button {
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 4px;
    background-color: #1976d2;
    color: white;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  button:not(:disabled):hover {
    background-color: #115293;
  }

  .margem {
    margin-top: 70px;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 100px;
  }

  .input-container {
    display: flex;
    align-items: center;
  }

  .card {
    width: 100%;
    max-width: 100%;
    border: 1px solid #ccc;
    padding: 0px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
  }

  .image-container {
    width: 100%;
    text-align: center;
    background-color: #020c4a;
  }

  .image-container img {
    width: 100%;
    max-width: 300px;
    height: auto;
  }
  .text-left {
    text-align: left;
    font-family: Verdana, sans-serif;
    font-size: 16px;
    margin: 15px;
  }
</style>
